const operations = document.querySelector('.multiple_operations');
const hasSousTraitant = document.querySelectorAll('.has_sous_traitant');
const addButton = document.querySelector('#plus-operation');

const changeCocoonId = () => {
  if (addButton) {
    addButton.addEventListener('click', () => {
      let operations;
      const inputRegex = /.*\[(name|description)\]/

      setTimeout(() => {
        operations = document.querySelectorAll('.new-operation.nested-fields');
        operations.forEach(operation => {
          const operationCount = operation.dataset.counter;
          const operationInputs = operation.querySelectorAll('input');

          operationInputs.forEach(input => {
            const inputName = input.getAttribute('name');
            // If input attribute contains name or description
            if (inputRegex.test(inputName)) {
              const newInputName = inputName.replace(/\d{13}/, operationCount);
              input.setAttribute('name', newInputName);
            }
          })
        })
      }, 100)
    })
  }
}

const activateDestroy = () => {
  if (operations) {
    const activiteOperations = operations.querySelectorAll('input[type=checkbox]');
    activiteOperations.forEach(act_op => {
      act_op.addEventListener('change', () => {
        const destroyField = event.target.parentElement.querySelector('.destroy_act_op');
        if (destroyField) {
          destroyField.value = destroyField.value === '' ? '1' : '';
        }
      });
    });
  }
}

const addSousTraitant = () => {
  if (hasSousTraitant.length > 0) {
    hasSousTraitant.forEach(checkbox => {
      checkbox.addEventListener('change', (e) => {
        const parentElement = e.currentTarget.parentElement.parentElement;
        const addButton = parentElement.querySelector('.add_fields.add-sous-traitant');
        const sousTraitantsFields = parentElement.querySelectorAll('.sous-traitant.nested-fields');
        const hiddenSousTraitant = parentElement.parentElement.nextElementSibling;
        // [...sousTraitantsFields, hiddenSousTraitant].forEach(element => {
        //   element.classList.toggle('d-hidden', !checkbox.checked);
        // });
      });
    });
  }
}

const updateSousTraitantIntervenants = () => {
  const sousTraitants = document.querySelectorAll('.sous-traitant.nested-fields');
  if (sousTraitants.length > 0) {
    sousTraitants.forEach(st => {
      const visibleInput = st.querySelector('.bootstrap-tagsinput');
      const hiddenInput = st.querySelector('.inter-hidden');
      visibleInput.addEventListener('change', () => {
        hiddenInput.value = visibleInput.innerText
      })
    })
  }
}

const modeOperatoire = () => {
  activateDestroy();
  // addSousTraitant();
  changeCocoonId();
  // updateSousTraitantIntervenants();
}

export default modeOperatoire;
